export const successCaseIntro = {
    title: '成功案例',
    subtitle:
        '匯融科技協助半導體、製造科技、一般企業及政府單位完成 Web、PDA 與長照等客製化軟體開發；合作專案亦涵蓋 AI 應用、智慧進銷存、派工維修與社區管理等類型，以下依產業別整理代表性客戶。',
    seoNote:
        '案例類型包含 AI 應用系統（智能客服、文件辨識）、進銷存及訂單／庫存管理、長照與政府表單簽核等，展現匯融在委外開發與 AI 進銷存領域的實務經驗。',
};

export const industryOrder = [
    '半導體業',
    '製造業及科技業',
    '一般公司及服務業',
    '政府部門',
];

export const industryMeta = {
    半導體業: {
        id: 'semiconductor',
        tag: '半導體',
        summary:
            '涵蓋晶圓製造、測試與設備管理等領域，提供 Windows 應用、工廠設備管理與客製化軟體開發；部分客戶亦導入 AI 應用輔助營運決策。',
    },
    製造業及科技業: {
        id: 'manufacturing',
        tag: '製造科技',
        summary:
            '服務電子、通訊與科技大廠，專案包含 AGV 倉儲、燒機測試、智慧看板、專案管理、進銷存、AI 進銷存整合及派工維修等系統。',
    },
    一般公司及服務業: {
        id: 'enterprise',
        tag: '企業服務',
        summary:
            '跨足零售、長照、展覽、貿易與社區管理等產業，提供 Web、APP、會員管理、進銷存、社區門禁與 AI 應用等多元系統。',
    },
    政府部門: {
        id: 'government',
        tag: '政府專案',
        summary:
            '協助中央與地方政府及學校單位建置表單簽核、校務行政、資料管理與對外服務系統，符合公部門資訊安全與作業流程需求。',
    },
};

export const getIndustryId = (industryKind) =>
    industryMeta[industryKind]?.id || industryKind;
